var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5845V15.5845H2V8.58453C2 7.2012 2.41667 5.97203 3.25 4.89703C4.08333 3.82203 5.16667 3.11787 6.5 2.78453V2.08453C6.5 1.66787 6.64583 1.3137 6.9375 1.02203C7.22917 0.730367 7.58333 0.584534 8 0.584534C8.41667 0.584534 8.77083 0.730367 9.0625 1.02203C9.35417 1.3137 9.5 1.66787 9.5 2.08453V2.78453C10.8333 3.11787 11.9167 3.82203 12.75 4.89703C13.5833 5.97203 14 7.2012 14 8.58453V15.5845H16V17.5845H0ZM8 20.5845C7.45 20.5845 6.97917 20.3887 6.5875 19.997C6.19583 19.6054 6 19.1345 6 18.5845H10C10 19.1345 9.80417 19.6054 9.4125 19.997C9.02083 20.3887 8.55 20.5845 8 20.5845ZM4 15.5845H12V8.58453C12 7.48453 11.6083 6.54287 10.825 5.75953C10.0417 4.9762 9.1 4.58453 8 4.58453C6.9 4.58453 5.95833 4.9762 5.175 5.75953C4.39167 6.54287 4 7.48453 4 8.58453V15.5845Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.508c4371463378c09af4c59b7eae98dc.svg";
export { ForwardRef as ReactComponent };